'use strict';

/**
 * @module BaseView
 * @author Philip & Micha
 */

const EventHelper = require('../helpers/event');

class BaseView {
	constructor (options) {
		this.parent = options.parent; // needed for templateHelper stuff
	}
	
	remove () {
		if (this.$el) {
			this.$el.remove();
			EventHelper.removeListeners(this);
			delete this;
		} else {
			// not yet rendered
			setTimeout(() => {
				this.remove();
			}, 100);
		}
	}
}

module.exports = BaseView;
